<template>
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
        <div class="container-fluid">
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li class="nav-item dropdown">
                        <router-link to="#" class="nav-link dropdown-toggle" id="navbar-dropdown-masterps" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            Data Pasien
                        </router-link>
                        <ul class="dropdown-menu" aria-labelledby="navbar-dropdown-masterps">
                            <li class="nav-item">
                                <router-link to="/update-pasien" class="dropdown-item"><i class="fa fa-user-circle"></i>
                                    Master Pasien</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/merge-data-pasien" class="dropdown-item"><i class="fa fa-users"></i>
                                    Merge Pasien</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/nonaktif-data-pasien" class="dropdown-item"><i
                                        class="fa fa-user-times"></i> Non Aktif Pasien</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/ganti-nomor-rm" class="dropdown-item"><i class="fa fa-refresh"></i>
                                    Ganti Nomor RM</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/scan-berkas-rm" class="dropdown-item"><i
                                        class="fa fa-file-archive-o"></i> Scan Berkas RM</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/ganti-registrasi" class="dropdown-item"><i
                                        class="fa fa-refresh"></i> Ganti No Registrasi</router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="nav-item dropdown">
                        <router-link to="#" class="nav-link dropdown-toggle" id="navbar-dropdown-trackps" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            Retensi dan Pemusnahan
                        </router-link>
                        <ul class="dropdown-menu" aria-labelledby="navbar-dropdown-trackps">
                            <li class="nav-item">
                                <router-link to="/pasien-tidak-aktif-5-tahun" class="dropdown-item"><i
                                        class="fa fa-user-times"></i> Pasien Tidak Aktif 5 Tahun</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/data-mr-tidak-aktif" class="dropdown-item"><i
                                        class="fa fa-user-times"></i> Data MR Tidak Aktif</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/laporan-retensi-dan-pemusnahan" class="dropdown-item"><i
                                        class="fa fa-file-text-o"></i> Laporan Retensi dan Pemusnahan</router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="nav-item dropdown">
                        <router-link to="#" class="nav-link dropdown-toggle" id="navbar-dropdown-trackps" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            Tracking Pasien
                        </router-link>
                        <ul class="dropdown-menu" aria-labelledby="navbar-dropdown-trackps">
                            <li class="nav-item">
                                <router-link to="/pasien-check-in" class="dropdown-item"><i class="fa fa-sign-in"></i>
                                    Pasien Check-In</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/konsul-antar-poli" class="dropdown-item"><i
                                        class="fa fa-bullhorn"></i> Konsul Antar Poli</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/pasien-dirawat" class="dropdown-item"><i class="fa fa-bed"></i> Pasien
                                    Dirawat</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/pasien-meninggal" class="dropdown-item"><i
                                        class="fa fa-user-times"></i> Pasien Meninggal</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/selesai-pelayanan" class="dropdown-item"><i class="fa fa-clock-o"></i>
                                    Selesai Pelayanan</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/pencarian-pasien" class="dropdown-item"><i class="fa fa-search"></i>
                                    Pencarian Pelayanan Pasien</router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="nav-item dropdown">
                        <router-link to="#" class="nav-link dropdown-toggle" id="navbar-dropdown-trackps" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            ICD X & ICD 9
                        </router-link>
                        <ul class="dropdown-menu" aria-labelledby="navbar-dropdown-trackps">
                            <li class="nav-item">
                                <router-link to="/master-icdx" class="dropdown-item"><i class="fa fa-bullhorn"></i>
                                    Master ICD X</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/master-icd9" class="dropdown-item"><i class="fa fa-bullhorn"></i>
                                    Master ICD 9</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/pasien-icd" class="dropdown-item"><i class="fa fa-user"></i> Input ICD
                                    Pasien</router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="nav-item dropdown">
                        <router-link to="#" class="nav-link dropdown-toggle" id="navbar-dropdown-trackps" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            Laporan External
                        </router-link>
                        <ul class="dropdown-menu" aria-labelledby="navbar-dropdown-trackps">
                            <li class="nav-item">
                                <router-link to="/external-rs" class="dropdown-item"><i class="fa fa-bullhorn"></i> Data
                                    Dasar Rumah Sakit</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/external-pelayanan" class="dropdown-item"><i
                                        class="fa fa-bullhorn"></i> Indikator Pelayanan</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/external-tempat-tidur" class="dropdown-item"><i
                                        class="fa fa-bullhorn"></i> Tempat Tidur</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/external-ketenagaan" class="dropdown-item"><i
                                        class="fa fa-bullhorn"></i> Ketenagaan</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/external-ranap" class="dropdown-item"><i class="fa fa-bullhorn"></i>
                                    Rawat Inap</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/external-darurat" class="dropdown-item"><i class="fa fa-bullhorn"></i>
                                    Rawat Darurat</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/external-gigi-mulut" class="dropdown-item"><i
                                        class="fa fa-bullhorn"></i> Kesehatan Gigi dan Mulut</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/external-pengunjung" class="dropdown-item"><i
                                        class="fa fa-bullhorn"></i> Pengunjung</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/external-kunjungan-rajal" class="dropdown-item"><i
                                        class="fa fa-bullhorn"></i> Kunjungan Rawat Jalan</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/external-penyakit-ranap" class="dropdown-item"><i
                                        class="fa fa-bullhorn"></i> 25 Besar Penyakit Rawat Inap</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/external-penyakit-rajal" class="dropdown-item"><i
                                        class="fa fa-bullhorn"></i> 25 Besar Penyakit Rawat Jalan</router-link>
                            </li>
                            <!-- <li class="nav-item">
                                    <router-link to="/external-kebidanan" class="dropdown-item"><i class="fa fa-bullhorn"></i> Kebidanan</router-link>
                                </li>
                                <li class="nav-item">
                                    <router-link to="/external-pernatologi" class="dropdown-item"><i class="fa fa-bullhorn"></i> Pernatologi</router-link>
                                </li>
                                <li class="nav-item">
                                    <router-link to="/external-pembedahan" class="dropdown-item"><i class="fa fa-bullhorn"></i> Pembedahan</router-link>
                                </li>
                                <li class="nav-item">
                                    <router-link to="/external-kegiatan-radiologi" class="dropdown-item"><i class="fa fa-bullhorn"></i> Kegiatan Radiologi</router-link>
                                </li>
                                <li class="nav-item">
                                    <router-link to="/external-laboratorium-biaya" class="dropdown-item"><i class="fa fa-bullhorn"></i> Laboratorium Biaya Pemeriksaan</router-link>
                                </li> -->
                        </ul>
                    </li>
                </ul>

               <UserDropDown />
            </div>
        </div>
    </nav>
</template>

<script>
import UserDropDown from '../global/UserDropDown.vue';


export default {
    components: {
        UserDropDown
    }
}
</script>
